import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// import createLogger from 'vuex/dist/logger'
import config from '@/config'
import { merge } from 'lodash'

// global modules
import auth from '@/modules/auth/store'
import admin from '@/modules/admin/store'
import objects from '@/modules/objects/store'
import profile from '@/modules/profile/store'
import editor from '@/modules/editor/store'
import dashboard from '@/modules/dashboard/store'
import manager from '@/modules/manager/store'
import client from '@/modules/client/store'
import partners from '@/modules/partners/store'
import partner from '@/modules/partner/store'
import dictionaries from '@/modules/dictionaries/store'
import content from '@/modules/content/store'
import objectmanager from '@/modules/objectmanager/store'
import schedule from '@/modules/schedule/store'
import job from '@/modules/job/store'
import checklist from '@/modules/checklist/store'
import shop from '@/modules/shop/store'
import seo from '@/modules/seo/store'
import development from '@/modules/development/store'

// local modules
import dictionary from './dictionary'

Vue.use(Vuex)

let isDevelopment = process.env.NODE_ENV !== 'production'
let vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: config.namespace,
  modules: ['auth']
})

let store = {
  modules: {
    app: {
      state: {
        snack: null,
        requests: 0
      },

      mutations: {
        showSnack(state, snack) {
          state.snack = snack
        },

        incRequestsCount(state) {
          state.requests++
        },

        decRequestsCount(state) {
          state.requests--
        }
      },

      namespaced: true
    }
  },

  plugins: [vuexLocal.plugin]
}

// Включим отладку в режиме разработки
if (isDevelopment) {
  // store.plugins.push(createLogger())
}

Object.assign(
  store.modules,
  auth,
  admin,
  manager,
  profile,
  objects,
  editor,
  dashboard,
  client,
  partners,
  dictionary,
  partner,
  content,
  dictionaries,
  schedule,
  objectmanager,
  job,
  checklist,
  shop,
  seo,
  development
)

export function withDataFilter(store) {
  return merge(store, {
    state: {
      dataFilter: {}
    },
    mutations: {
      setDataFilter(state, filter) {
        Vue.set(state, 'dataFilter', {
          ...merge(state.dataFilter, filter)
        })
      }
    }
  })
}

export default new Vuex.Store(store)
